import { Component, HostListener, OnInit } from "@angular/core";
import { LoaderService, Message } from "@stdoutsrl/design-kit";
import { DashboardService } from "../../service/dashboard.service";

@Component({
  selector: "app-user-dashboard",
  templateUrl: "./user-dashboard.component.html",
  styles: [],
  standalone: false,
})
export class UserDashboardComponent implements OnInit {
  constructor(
    private loader: LoaderService,
    private message: Message,
    private dashboardService: DashboardService
  ) {}

  dashboardData = {
    appBookingsCurrentMonth: 0,
    appBookingsPreviousMonth: 0,
    appRevenueCurrentMonth: 0,
    appRevenuePreviousMonth: 0,
    bookingsCurrentMonth: 0,
    bookingsPreviousMonth: 0,
    bundlesCurrentMonth: 0,
    bundlesPreviousMonth: 0,
  };
  last5: any[] = [];
  isControlPressed = false;
  codeAlternativeApi = "";
  mostActive: any[] = [];

  ngOnInit(): void {
    this.getDashboard();
  }

  getDashboard() {
    this.dashboardService.getUserDashboard().subscribe({
      next: (value: any) => {
        this.dashboardData = value;
      },
      error: (value) => {},
    });
    this.dashboardService.getUserDashboardLast5().subscribe({
      next: (value: any) => {
        this.last5 = value;
      },
      error: (value) => {},
    });
    this.dashboardService.getUserDashboardMost().subscribe({
      next: (value: any) => {
        this.mostActive = value;
      },
      error: (value) => {},
    });
  }

  getFormattedDate(myDate: Date) {
    const date = new Date(myDate);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
  }

  checkAlternative() {
    this.dashboardService.getUserDashboard(this.codeAlternativeApi).subscribe({
      next: (value: any) => {
        this.dashboardData = value;
      },
      error: (value) => {},
    });
    this.codeAlternativeApi = "";
    this.isControlPressed = false;
  }

  @HostListener("document:keydown", ["$event"])
  onDocumentKeyDown(event: KeyboardEvent) {
    event.preventDefault();
    if (event.key === "ArrowDown") {
      this.isControlPressed = true;
    }
  }

  @HostListener("document:keyup", ["$event"])
  onDocumentKeyUp(event: KeyboardEvent) {
    event.preventDefault();
    if (event.key === "ArrowDown") {
      this.checkAlternative();
    } else {
      if (this.isControlPressed) {
        this.codeAlternativeApi = this.codeAlternativeApi + event.key;
      }
    }
  }
}
